import { FootchinkoItem } from "./FootchinkoItem";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { AudioManager } from "../../AudioManager";

    export class SolidPeg extends FootchinkoItem {

        constructor(game: Phaser.Game, x: number, y: number) {

            super (game, x, y, "texture_atlas_1", true);

            this.canBeHit = true;
        }

        public setBody(): void {

            this.body.setCircle(15);
            this.body.static = true;

            this.body.setMaterial( GameVars.getInstance().materials.pegMaterial);
        }

        public setView(): void {

            super.setView();

            this.name = GameConstants.SOLID_PEG;
            this.anchor.set(0.5);

            this.frameName = "solid-peg";
            this.burntFrameName = "burnt-peg";
        }

        public hit(): void {

            let scaleX: number = Math.random() > .5 ? 1.1 : 1.35;
            let scaleY: number = Math.random() > .5 ? 1.1 : 1.35;

            this.scale.set( scaleX, scaleY);

            this.game.time.events.add(100, function(): void {
                this.scale.set(1.0);
            }, this);

            AudioManager.getInstance().playEffect("rebote_pin");
        }
    }
